import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { SLICE_NAMESPACE } from '../../constants';
import { INavigationState } from '../../types';

/**
 * The loading state is only applied to the trees status
 */

export const fetchTreesAlternativeLoading = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/fetchTreesAlternativeLoading`,
  async (_, { getState }) => {
    const {
      navigation: {
        navigationList: { pagination },
      },
    } = getState();
    return apiService.navigation.getNavigationTrees({ page: pagination.currentPage });
  },
);

export const fetchTreesAlternativeLoadingReducer: TSliceExtraReducer<INavigationState> = builder =>
  builder
    .addCase(fetchTreesAlternativeLoading.pending, state => {
      state.navigationList.loading.status = true;
    })
    .addCase(fetchTreesAlternativeLoading.rejected, state => {
      state.navigationList.loading.status = false;
      state.navigationList.trees = [];
    })
    .addCase(fetchTreesAlternativeLoading.fulfilled, (state, action) => {
      state.navigationList.loading.status = false;
      state.navigationList.trees = action.payload.trees;
      state.navigationList.pagination = action.payload.pagination;
    });
